//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { dateFormat, datetimeFormat } from '@/plugin/format.js'
import moment from 'moment'
export default {
  data () {
    return {
      devicesdata: [],
      filters: {
        keyword: '',
        model: '',
        seriesno: '',
        fromTime: null,
        toTime: null,
        state: ''
      },
      dataForm: {},
      total: 0,
      currentPage: 1,
      pageSize: 20,
      editDialogVisible: false,
      pickerOptionsS: {
        disabledDate: time => {
          if (this.filters.toTime !== null) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() > this.filters.toTime
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      pickerOptionsE: {
        disabledDate: time => {
          return (
            time.getTime() < this.filters.fromTime ||
            time.getTime() > Date.now()
          )
        }
      }
    }
  },
  methods: {
    querylist: function () {
      this.currentPage = 1
      this.getlist()
    },
    getlist: function () {
      let params = {
        Keyword: this.filters.keyword.trim(),
        Model: this.filters.model.trim(),
        SeriesNO: this.filters.seriesno.trim(),
        ImportTimeFrom: moment(this.filters.fromTime)
          .utcOffset(480)
          .format('YYYY-MM-DD HH:mm:ss'),
        ImportTimeTo: moment(this.filters.toTime)
          .utcOffset(480)
          .format('YYYY-MM-DD HH:mm:ss')
      }
      if (this.filters.state) {
        params.State = this.filters.state
      } else {
      }

      params.PageIndex = this.currentPage - 1
      params.PageSize = this.pageSize
      this.$api
        .getDeviceBypage(params)
        .then(res => {
          if (res.Status === 1) {
            this.devicesdata = res.Entity
            this.total = res.TotalRowsCount
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function (res) {
          this.$alert('获取保修信息错误！', '错误', {
            confirmButtonText: '确定'
          })
        })
    },
    handleEdit: function (row) {
      this.editDialogVisible = true
      let df = Object.assign({}, row)
      this.dataForm = df
    },
    handleSave: function () {
      let params = {
        UserName: this.dataForm.UserName,
        Model: this.dataForm.Model,
        SeriesNO: this.dataForm.SeriesNO,
        PDate: this.dataForm.PDate,
        WLimit: this.dataForm.WLimit,
        EXWLimit: this.dataForm.EXWLimit,
        Description: this.dataForm.Description,
        ImportTime: this.dataForm.ImportTime
      }
      this.$api.deviceSave(params).then(res => {
        if (res.Status === 1) {
          this.$message({ message: '保存成功', type: 'success' })
          this.getlist()
        } else {
          this.$alert(res.Message, '错误', {
            confirmButtonText: '确定'
          })
        }
      })
    },
    handleDelete: function (dev) {
      this.$confirm(
        '确认删除这台设备吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        var params = []
        params.push({
          Model: dev.Model,
          SeriesNO: dev.SeriesNO
        })
        this.$api.deviceDelete(params).then(res => {
          if (res.Status === 1) {
            this.$message({
              message: '设备删除成功',
              type: 'success'
            })

            this.getlist()
          } else {
            this.$alert(res.Message.replace(/\n\r/g, '</br>'), '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    visibleChange (isVisible) {
      const isEdge = window.navigator.userAgent.includes('Edge')
      if (isEdge && !isVisible) {
        document
          .querySelectorAll('body > .el-select-dropdown.el-popper')
          .forEach((it) => it.remove())
      }
    },
    dateFormat: function (row, column) {
      let time = dateFormat(row, column)
      return time
    },
    datetimeFormat: function (row, column) {
      let time = datetimeFormat(row, column)
      return time
    },
    sizeChange: function (size) {
      this.pageSize = size
      this.getlist()
    },
    refreshPageRequest: function (pageNum) {
      this.currentPage = pageNum
      this.getlist()
    }
  },
  created () { }
}



// WEBPACK FOOTER //
// ./src/admin/AdminDevice.vue